<nav class="navbar navbar-expand-sm navbar-dark bg-dark">
    <div class="container-fluid mx-sm-5">
        <div>
            <img src="../../assets/img/logo.png" width="50" height="50">
            <a href="#" class="navbar-brand px-2">Jack technology</a>
        </div>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent">
          <span class="navbar-toggler-icon"></span>
      </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <a class="nav-link active" href="#">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="Product">Products</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#contactus">Contact</a>
                </li>
            </ul>
        </div>
    </div>
</nav>